import React, { useState } from "react";
import { updatePassword } from "firebase/auth";
import { auth } from "./Firebase";
import styled from "styled-components";
import { EstiloButton } from "./App";
import { Alert, CloseButton } from "./App";
import { RiLockPasswordLine } from "react-icons/ri";

const FormGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 2px;
  & label {
    font-weight: bold;
  }
  & input,
  select,
  textarea {
    background-color: rgba(255, 255, 255, 0.4);
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 200px;
    &:focus {
      outline: none;
      color: #1f2124;
    }
  }
`;
const ContenedorDiv = styled.div`
  display: flex;
  margin: auto;
  margin-bottom: 4rem;
  width: 350px;
  height: 65vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & input {
    width: 170px;
  }
  & p {
    font-size: small;
  }
`;
const ContenedorFormBase = styled.form`
  text-align: left;
  width: 380px;
  margin: 0.7rem 1rem 0 1rem;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;

const ModificarContraseña = () => {
  const [nuevaContraseña, setNuevaContraseña] = useState("");
  const [confirmarContraseña, setConfirmarContraseña] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nuevaContraseña || !confirmarContraseña) {
      setShowAlert(true);
      return;
    }

    // Validar que las contraseñas coincidan
    if (nuevaContraseña !== confirmarContraseña) {
      setMensaje("Las contraseñas no coinciden.");
      return;
    }

    // Validar que la contraseña cumple con los requisitos
    const contraseñaRequerimientos = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

    if (!contraseñaRequerimientos.test(nuevaContraseña)) {
      setMensaje(
        "La contraseña debe contener al menos 6 caracteres, " +
          "1 número, 1 letra mayúscula y 1 letra minúscula."
      );
      return;
    }

    // Cambiar la contraseña del usuario autenticado
    try {
      await updatePassword(auth.currentUser, nuevaContraseña);
      setMensaje("Contraseña actualizada correctamente. Actualice la página.");
    } catch (error) {
      setMensaje("Error al actualizar la contraseña: " + error.message);
    }
  };

  return (
    <ContenedorDiv>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Complete los campos para modificar su contraseña.
        </Alert>
      )}
      <RiLockPasswordLine size={60}/>
      <h3>Modificar Contraseña.</h3>
      <p>
        Mínimo 6 caracteres que contenga al menos un número, una letra mayúscula
        y una letra minúscula.
      </p>
      <ContenedorFormBase onSubmit={handleSubmit}>
        <FormGroup>
          <label>Nueva Contraseña:</label>
          <input
            type="password"
            value={nuevaContraseña}
            onChange={(e) => setNuevaContraseña(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label>Confirmar:</label>
          <input
            type="password"
            value={confirmarContraseña}
            onChange={(e) => setConfirmarContraseña(e.target.value)}
          />
        </FormGroup>
        <EstiloButton type="submit">Actualizar</EstiloButton>
      </ContenedorFormBase>
      <p>{mensaje}</p>
    </ContenedorDiv>
  );
};

export default ModificarContraseña;